export const LogsType = {
  SELENIUM: "selenium",
  CONSOLE: "console",
  TERMINAL: "terminal",
  TELEMETRY: "telemetry",
  CYPRESS_CONSOLE: "cypress-console",
  CDP_CONSOLE: "cdp-console",
  DEVICE_LOGS: "devicelog",
  PLAYWRIGHT_TRACE_LOGS: "playwrightTraceLogs"
};

export const LogsName = {
  selenium: "Selenium Logs",
  console: "Console Logs",
  terminal: "Terminal Logs",
  telemetry: "Telemetry Logs",
  appium: "Appium Logs",
  devicelog: "Device Logs",
  playwrightTraceLogs: "Playwright Logs"
};

export const DisplayName = {
  selenium: "Selenium",
  console: "Console",
  terminal: "Terminal",
  telemetry: "Telemetry",
  appium: "Appium",
  devicelog: "Device",
  playwrightTraceLogs: "Playwright"
};